import type { MtbTrailRelatedPlace, RelatedPlace } from "~/lib/api";
import { TrailListItem } from "~/components/place/mtb/TrailListItem";

interface PlaceTrailsProps {
  trails: MtbTrailRelatedPlace[];
  onSelect?: (place: RelatedPlace) => void;
}

export function PlaceTrails({ trails, onSelect }: PlaceTrailsProps) {
  return (
    <div className="flex flex-col">
      {trails.map((trail) => (
        <TrailListItem key={trail.id} place={trail} onSelect={() => onSelect?.(trail)} />
      ))}
    </div>
  );
}
